import { registerComponent } from '@gig/magic-common';
import KeycloakTnCComponent from './keycloak-tnc.vue.js';

var KeycloakTnC = registerComponent(KeycloakTnCComponent);

export { KeycloakTnC };
